import { IkeFieldType, type SubFormEquipmentTypeState } from '@ikegps/core-api';
import type { FormModelField } from '../../form.field';
import { FormModelFieldSelectList } from '../../form.select.list';
import { getOtherAssignedSubformFieldIds } from '../form.subform.field.util';

const DEFAULT_EQUIPMENT_TYPE_VALUES = new Set([
	'Capacitor Bank',
	'Crossarm',
	'Recloser',
	'Regulator',
	'Riser',
	'Streetlight',
	'Transformer - Single Phase',
	'Transformer - Three Phase',
	'Switch',
]);

export function isValidDefaultEquipmentTypeSelectList(field: FormModelField): boolean {
	if (!FormModelFieldSelectList.isSelectList(field)) {
		return false;
	}
	const options = field.options.filter((opt) => opt.value !== FormModelFieldSelectList.UNSELECTED_VALUE);
	if (options.length !== DEFAULT_EQUIPMENT_TYPE_VALUES.size) {
		return false;
	}
	return options.every((opt) => DEFAULT_EQUIPMENT_TYPE_VALUES.has(opt.text));
}

export function isValidEquipmentTypeField(field: FormModelField): boolean {
	const excludeId = field.parent?.stateValue.equipmentTypeState?.typeFieldId;
	const otherIds = getOtherAssignedSubformFieldIds(field, excludeId);
	return (
		(field.type === IkeFieldType.SELECT_LIST || field.type === IkeFieldType.NESTED_LIST) && !otherIds.includes(field.id)
	);
}

export function isValidOrientationField(field: FormModelField): boolean {
	const excludeId = field.parent?.stateValue.equipmentTypeState?.orientationFieldId;
	const otherIds = getOtherAssignedSubformFieldIds(field, excludeId);
	return (
		field.type === IkeFieldType.ORIENTATION || (field.type === IkeFieldType.NUMBER && !otherIds.includes(field.id))
	);
}

export function isValidEquipmentHeightField(
	field: FormModelField,
	excludeKey: keyof SubFormEquipmentTypeState
): boolean {
	const excludeId = field.parent?.stateValue.equipmentTypeState?.[excludeKey];
	const otherIds = getOtherAssignedSubformFieldIds(field, excludeId);
	return field.type === IkeFieldType.HEIGHT && !otherIds.includes(field.id);
}
